export default {
  title: 'Ostoskori',
};
